import { defaultLang }  from './constant'
export const languages = [defaultLang,  'zh' ,'en'];
export const defaultNS = 'translation';
export function getOptions(defaultLang, ns = defaultNS) {
  return {
    defaultLocale: 'vn',
    supportedLngs: languages,
    fallbackLng : [defaultLang],
    lng :'vn',
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
